import { lazy } from 'react';

export const ProfilesPage = lazy(() => import('./ProfilesPage'));
